import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import Loader from "Components/loader/Loader";
import PropTypes from "prop-types";
import * as resActions from "../../modules/resources";
import Tabs from "Components/tabs/Tabs";
import PersonalData from "./settings/PersonalData";
import Order from "./settings/Order";
import Notifications from "./settings/Notifications";
import Security from "./settings/Security";
import Limits from "./settings/Limits";
import System from "./settings/System";
import Delivery from "./settings/Delivery";
import { displayFormattedDate } from "Utils/dateFormats";
import QboxmailApi from "../../qboxmailApi";
import { alertSuccess } from "Utils/alerts";
import withFormState from "Components/withFormState";
import * as tokenActions from "../../modules/apitoken";
import { formatServerErrors } from "Utils/serverFormats";

import ButtonBack from "Components/buttonBack/ButtonBack";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";

import t from "Utils/translation";
import cx from "classnames";
import s from "./showCustomers.scss";

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

const formInitialState = {};

class CustomerShowScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showInfo: this.props.isMediaMobile ? false : true };
  }

  UNSAFE_componentWillMount() {
    this.props.getCustomer(this.props.match.params.customerCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (!nextProps.isCustomerLoading && this.props.isCustomerLoading) ||
      (!nextProps.isRefreshingCustomer && this.props.isRefreshingCustomer)
    ) {
      const customer = nextProps.customer;
      this.props.setInitialValues({
        firstname: customer.firstname,
        lastname: customer.lastname,
        email_address: customer.email_address,
        language: customer.language,
        timezone: customer.timezone,
        max_domains: customer.max_domains,
        max_email_accounts: customer.max_email_accounts,
        max_email_accounts_25gb: customer.max_email_accounts_25gb,
        max_email_accounts_50gb: customer.max_email_accounts_50gb,
        max_email_accounts_100gb: customer.max_email_accounts_100gb,
        max_email_accounts_archive: customer.max_email_accounts_archive,
        max_email_quota: customer.max_email_quota,
        is_wholesale: customer.is_wholesale,
        is_reseller: customer.is_reseller,
        catch_all: customer.catch_all,
        plan: customer.plan,
        expiration: customer.expiration,
        email_overquota_email: customer.email_overquota_email,
        notification_email: customer.notification_email,
        domain_create_callback: customer.domain_create_callback,
        email_overquota_callback: customer.email_overquota_callback,
        notification_url: customer.notification_url,
        whmcs_id: customer.whmcs_id,
        can_edit_outbound_limits: customer.can_edit_outbound_limits,
        storage: customer.storage,
        max_delivery_account_free: customer.max_delivery_account_free,
        distributor_id: customer.distributor_id,
        domain_limit_tracemail_21_days_default: customer.domain_limit_tracemail_21_days_default,
      });
    }

    const hasJustDeletedOrder = !nextProps.isOrderDeleting && this.props.isOrderDeleting;
    if (hasJustDeletedOrder) {
      alertSuccess(t("alert.order.deleted"));
      this.props.refreshCustomer(this.props.match.params.customerCode);
    }
  }

  validate(values) {
    let errors = {};
    const requiredFields = ["firstname", "lastname"];
    for (let i = 0; i < requiredFields.length; i++) {
      if (!values[requiredFields[i]]) errors[requiredFields[i]] = "is required";
    }
    return errors;
  }

  deleteOrder = (id) => {
    this.props.deleteOrder(id);
  };

  submitForm = (e, fieldsToSend = []) => {
    const {
      refreshCustomer,
      setFormLoading,
      unsetFormLoading,
      setFormErrors,
      formData,
      setInitialValues,
      match: {
        params: { customerCode },
      },
    } = this.props;
    e.preventDefault();
    setFormLoading();
    const values = _.clone(formData);
    const errors = this.validate(formData);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      const dataToSend = {};
      fieldsToSend.forEach((f) => (dataToSend[f] = values[f]));

      const api = new QboxmailApi({ useCookie: true });
      api
        .editCustomer(customerCode, dataToSend)
        .then((response) => {
          unsetFormLoading();
          setFormErrors({});
          setInitialValues(formData);
          alertSuccess(t("alert.customer.updated"));
          refreshCustomer(customerCode);
        })
        .catch((response) => {
          formatServerErrors(response).then((errors) => {
            setFormErrors(errors);
            unsetFormLoading();
          });
        });
    }
  };

  goBack = () => {
    const { location } = this.props;
    const query = _.get(location, "state.prevPagination", "");
    this.props.history.push("/customers" + query);
  };

  toggleInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };

  render() {
    const { isCustomerLoading, customer } = this.props;

    const { showInfo } = this.state;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    if (isCustomerLoading) {
      return <Loader {...this.props} />;
    }
    return (
      <div className={s.customerSettings}>
        <div className={s.navigation}>
          <ButtonBack onClick={this.goBack} label={t("button.backCustomers")} />
          <div className={s.viewSectionLabel}>{t("section.view.customer")}</div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">{`${customer.firstname} ${customer.lastname}`}</div>
            {isMediaMobile() && (
              <div className={cx(s.showInfo, "internalLink")} onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>

          {showInfo && (
            <div className={s.subtitle}>
              <DetailStatus status={customer.status} />
              <div className="sectionDesc">{customer.email_address}</div>
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={customer.code} />
              <DetailInfo label={t("detailInfo.label.created")} info={displayFormattedDate(customer.created_at)} />
            </div>
          )}
        </div>

        <Tabs
          {...this.props}
          className={s.settings}
          tabs={{
            [t("tab.registry")]: <PersonalData submitForm={this.submitForm.bind(this)} {...this.props} />,
            [t("tab.general")]: <Limits submitForm={this.submitForm} {...this.props} />,
            [t("tab.security")]: <Security submitForm={this.submitForm} {...this.props} />,
            [t("tab.notification")]: <Notifications {...this.props} submitForm={this.submitForm} />,
            [t("tab.orders")]: <Order {...this.props} submitForm={this.submitForm} deleteOrder={this.deleteOrder} />,
            Sistema: <System {...this.props} submitForm={this.submitForm} defaultStorage={customer.default_storage} />,
            Delivery: <Delivery {...this.props} submitForm={this.submitForm} />,
          }}
        />
      </div>
    );
  }
}

CustomerShowScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  customer: resActions.getData("customer.data.0", state),
  isRefreshingCustomer: state.resources.customer && state.resources.customer.refreshResource,
  isCustomerLoading: resActions.isResourceLoading("customer", state),
  isOrderLoading: resActions.isResourceLoading("order", state),
  isOrderDeleting: state.resources.order && state.resources.order.deleting,
  isGeneratingToken: state.apitoken.isGenerating,
  isResettingToken: state.apitoken.isResetting,
  apiToken: state.apitoken.token,
  apiTokenResetted: state.apitoken.resetted,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomer: (code) => dispatch(resActions.callApi("getCustomer", "customer", code)),
  getOrder: (id) => dispatch(resActions.callApi("getOrder", "order", id)),
  refreshCustomer: (code) => dispatch(resActions.callApi("refreshCustomer", "customer", code)),
  generateApiToken: (userCode) => dispatch(tokenActions.generateApiToken(userCode)),
  destroyApiToken: (userCode) => dispatch(tokenActions.destroyApiToken(userCode)),
  deleteOrder: (id) => dispatch(resActions.callApi("deleteOrder", "order", id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(CustomerShowScreen, formInitialState));
